import { useEffect, useState } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import useModal, { MODAL_LG } from '../../../theme/Component/hooks/useModal';
import { toast } from 'react-toastify';
import { Modal } from '../../../theme/Component/Modal';
import { ShelfInventory } from './ShelfInventory';
import { _ShelfInventory } from '../../../../core/services/dataBean/EntityCatalog';

interface Props {
    label?: string;
    idStore: number;
    idSelector: number;
    onChange: (value: any) => void;
    disabled?: boolean;
    storeModify?: boolean;
}

export const EditorShelfInventory = ({ idStore, idSelector, label, onChange, disabled, storeModify = false }: Props) => {
    const { instance } = useDataBean(_ShelfInventory);

    const modal = useModal("Catálogo de Tipos Documentales", MODAL_LG);

    const [valor, setValor] = useState('');
    const [obj, setObj] = useState<any>({});

    useEffect(() => {
        if (idSelector) {
            getProduct();
        } else {
            setValor('');
            setObj({});
        }
    }, [idSelector]);

    const getProduct = () => {
        instance.getShelfInventory(idSelector).then(
            (resp: any) => {
                console.log(resp)
                setObj(resp);
                setValor(`${resp.Name}`);
                onChange(resp);
            }
        ).catch((e) => {
            toast.error("Estanteria/Ubicación Fisica no encontrada");
            setValor('');
            setObj({});
        });
    };

    const returnValue = () => {
        if (obj?.IDShelfInventory) {
            setValor(`${obj.Name}`);
            modal.close();
            onChange(obj);
        } else {
            toast.error("Estanteria/Ubicación Fisica no valida");
        }
    };

    return (
        <>
            {label && label !== " " && (
                <label>{label ?? "Seleccione una Estanteria/Ubicación Fisica"}</label>
            )}

            <div
                className={`form-control text-wrap ${disabled ? 'bg-light text-muted' : 'cursor-pointer'}`}
                style={{ minHeight: '35px' }}
                onClick={() => {
                    if (!disabled) {
                        modal.open();
                    }
                }}
            >
                {valor ? valor : <span>Seleccionar...</span>}
            </div>

            <Modal
                onSubmitLabel="Seleccionar"
                modal={modal.modal}
                updateModal={modal.setModal}
                eventModal={returnValue}
            >
                <ShelfInventory Store={{ IDStore: idStore }} _onChange={(e) => { setObj(e) }} storeModify={storeModify} />
            </Modal>
        </>
    );
};
